<template>
  <div class="page-wrap">
    <div class="header-filter">
      <div class="filter-title">
        <span class="title-text">素材测试信息同步</span>
      </div>
      <div class="select-wrap">
        <el-select class="select-item" v-model="filterData.afid" placeholder="玩法" filterable>
          <el-option label="全部玩法" :value="-1"> </el-option>
          <el-option
            v-for="item in productList"
            :key="item.id"
            :label="item.playName"
            :value="item.afid"
          >
            <span style="float: left">{{ item.playName }}</span>
            <span style="float: right; color: #8492a6; font-size: 13px">{{ item.afid }}</span>
          </el-option>
        </el-select>
        <el-select
          class="select-item"
          v-model="filterData.materialType"
          filterable
          placeholder="素材类型"
        >
          <el-option label="全部素材类型" :value="-1"> </el-option>
          <el-option label="视频" value="视频"> </el-option>
          <el-option label="gif" value="gif"> </el-option>
          <el-option label="psd" value="psd"> </el-option>
          <el-option label="图片" value="图片"> </el-option>
          <el-option label="playable" value="playable"> </el-option>
        </el-select>
        <el-select
          class="select-item"
          v-model="filterData.lang"
          filterable
          placeholder="请选择语言"
        >
          <el-option label="全部语言" :value="-1"> </el-option>
          <el-option
            v-for="item of langList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select
          class="select-item"
          v-model="filterData.materialEffect"
          placeholder="素材综合效果"
        >
          <el-option
            v-for="item in materialEffectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-date-picker
          class="data-range"
          v-model="filterData.time"
          type="daterange"
          range-separator="→"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
          :clearable="false"
        >
        </el-date-picker>
        <el-button style="margin-left: auto" @click="resetFilter">重置</el-button>
        <el-button type="primary" @click="searchData">查询</el-button>
      </div>
    </div>
    <div class="table-wrap">
      <div class="batch" v-if="multipleSelection.length > 0">
        <div class="batch-title">批量操作：</div>
        <el-select class="batch-select-item" v-model="filterBatch.channelId" placeholder="选择渠道">
          <el-option
            v-for="item in channelList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <el-select class="batch-select-item" v-model="filterBatch.effectId" placeholder="选择效果">
          <el-option
            v-for="item in effectList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <div class="batch-btn" @click="batchApply" :class="{ 'can-click': isCanClickApply }">
          应用
        </div>
      </div>
      <el-table
        :data="tableData"
        style="width: 100%; flex: 1; overflow: auto"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column
          v-for="item of columns"
          :key="item.value"
          :prop="item.value"
          :width="item.width || '120px'"
          :label="item.label"
          :fixed="item.fixed || null"
        >
          <template slot-scope="scope">
            <span v-if="item.value === 'select'"></span>
            <!-- 可编辑列 -->
            <div
              v-else-if="
                item.value === 'FB' ||
                item.value === 'GG' ||
                item.value === 'TT' ||
                item.value === 'unity' ||
                item.value === 'mintegral' ||
                item.value === 'toutiao' ||
                item.value === 'wechat' ||
                item.value === 'tencent' ||
                item.value === 'kuaishou' ||
                item.value === 'materialEffect'
              "
            >
              <check-select
                v-if="editDataSet[scope.row.id]"
                v-model="editDataSet[scope.row.id][item.value]"
                :saveType="scope.row[item.value]"
                :effectType="item.value"
                :isCanSetEffect="isCanSetEffect(editDataSet[scope.row.id])"
              ></check-select>
              <div v-else>
                <span
                  v-if="scope.row[item.value] === 0"
                  :class="['show-text', scope.row[item.value] === 0 ? 'wsc' : '']"
                  ><i class="el-icon-minus"></i
                ></span>
                <span
                  v-else-if="scope.row[item.value] === 1"
                  :class="['show-text', scope.row[item.value] === 1 ? 'ysc' : '']"
                  ><i class="el-icon-check"></i
                ></span>
                <span
                  v-else-if="scope.row[item.value] === 2"
                  :class="['show-text', scope.row[item.value] === 2 ? 'yx' : '']"
                  >有效</span
                >
                <span
                  v-else-if="scope.row[item.value] === 3"
                  :class="['show-text', scope.row[item.value] === 3 ? 'yxpro' : '']"
                  >有效+</span
                >
                <span
                  v-else-if="scope.row[item.value] === 4"
                  :class="['show-text', scope.row[item.value] === 4 ? 'dl' : '']"
                  >带量</span
                >
              </div>
            </div>

            <!-- 素材需求内容 -->
            <div v-else-if="item.value === 'materialRemark'">
              <el-popover
                placement="bottom"
                width="260"
                trigger="hover"
                :content="scope.row[item.value]"
              >
                <div class="show-text-area" slot="reference">
                  {{ scope.row[item.value] }}
                </div>
              </el-popover>
            </div>

            <!-- 备注 -->
            <div v-else-if="item.value === 'remark'">
              <div v-if="editDataSet[scope.row.id]">
                <el-input
                  class="input-area"
                  type="textarea"
                  :rows="3"
                  placeholder="请输入"
                  v-model="editDataSet[scope.row.id][item.value]"
                  resize="none"
                >
                </el-input>
              </div>

              <el-popover
                v-else
                placement="right"
                width="260"
                trigger="hover"
                :content="scope.row[item.value]"
              >
                <div class="show-text-area" slot="reference">
                  {{ scope.row[item.value] }}
                </div>
              </el-popover>
            </div>

            <!-- 操作 -->
            <div v-else-if="item.value === 'doSth'">
              <div v-if="editDataSet[scope.row.id]" class="edit-btns">
                <el-button type="text" size="small" @click="saveData(scope.row)">保存</el-button>
                <el-button type="text" size="small" @click="cancel(scope.row)">取消</el-button>
              </div>
              <el-button v-else type="text" size="small" @click="editLine(scope.row)"
                >编辑</el-button
              >
              <el-button type="text" size="small" @click="showLog(scope.row)">日志</el-button>
            </div>

            <!-- 只读数据 -->
            <span v-else>{{ scope.row[item.value] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <self-pagination
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="handleSizeChange"
    ></self-pagination>

    <!-- 日志弹框 -->
    <log-modal ref="logModalRef"></log-modal>
  </div>
</template>

<script>
import moment from "moment";
import CheckSelect from "./checkSelect.vue";
import LogModal from "./modals/logModal.vue";
import { materialEffectList, channelList } from "../confData.js";
import { getPlayInfoList } from "@/api/rolepower.js";
import { queryMaterialInfo, modifyMaterialStatus } from "@/api/materialManage.js";
import { langList } from "../confData.js";
export default {
  name: "MaterialCreate",
  components: {
    CheckSelect,
    LogModal,
  },
  data() {
    return {
      materialEffectList,
      channelList,
      filterData: {
        afid: -1,
        materialType: -1,
        lang: -1,
        materialEffect: -1,
        time: [
          moment().subtract(6, "days").format("YYYY-MM-DD"),
          moment().subtract(0, "days").format("YYYY-MM-DD"),
        ],
      },
      productList: [],
      langList: langList,
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      filterBatch: {
        channelId: null,
        effectId: null,
      },
      tableData: [],
      editDataSet: {},
      columns: [
        { label: "玩法名称", value: "appName", fixed: "left" },
        { label: "素材组名称", value: "materialName", fixed: "left" },
        { label: "语言", value: "lang" },
        { label: "素材类型", value: "materialType" },
        { label: "素材需求内容", value: "materialRemark", width: "260px" },
        { label: "素材综合效果", value: "materialEffect" },
        { label: "FB", value: "FB" },
        { label: "GG", value: "GG" },
        { label: "TT", value: "TT" },
        { label: "unity", value: "unity" },
        { label: "mintegral", value: "mintegral" },
        { label: "今日头条", value: "toutiao" },
        { label: "微信", value: "wechat" },
        { label: "广点通", value: "tencent" },
        { label: "快手", value: "kuaishou" },
        { label: "素材备注", value: "remark", width: "260px" },
        { label: "素材地址", value: "materialAddr" },
        { label: "素材完成时间", value: "finishDateStr" },
        { label: "操作", value: "doSth", width: "160px", fixed: "right" },
      ],
      multipleSelection: [],
    };
  },
  computed: {
    isCanClickApply() {
      return this.filterBatch.channelId && this.filterBatch.effectId;
    },
    effectList() {
      const list = [
        { label: "有效", value: 2 },
        { label: "有效+", value: 3 },
        { label: "带量", value: 4 },
      ];
      if (this.filterBatch.channelId !== "materialEffect") {
        list.unshift({ label: "已上传", value: 1 });
      }
      return list;
    },
  },
  mounted() {
    this.initSelect();
    this.searchData(true);
    this.multipleSelection = [];
  },
  methods: {
    // 判断素材综合效果是否能够设置为有效或有效+或带量
    isCanSetEffect(data) {
      const { FB, GG, TT, unity, mintegral, toutiao, wechat, tencent, kuaishou } = data;
      const max = Math.max.apply(null, [
        FB,
        GG,
        TT,
        unity,
        mintegral,
        toutiao,
        wechat,
        tencent,
        kuaishou,
      ]);
      return max > 1;
    },
    initSelect() {
      //玩法
      getPlayInfoList().then((res) => {
        this.productList = res.data.list;
      });
    },
    resetFilter() {
      this.filterData.afid = -1;
      this.filterData.materialType = -1;
      this.filterData.lang = -1;
      this.filterData.materialEffect = -1;
      this.filterData.time = [
        moment().subtract(6, "days").format("YYYY-MM-DD"),
        moment().subtract(0, "days").format("YYYY-MM-DD"),
      ];
      this.searchData(true);
    },
    searchData(resetpage) {
      if (resetpage) {
        this.pageData.page = 1;
        this.pageData.size = 10;
      }
      let parmas = {
        page: this.pageData.page + "",
        size: this.pageData.size + "",
        startTime: this.filterData.time[0],
        endTime: this.filterData.time[1],
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (key !== "time" && value !== -1) {
          parmas[key] = value + "";
        }
      }
      queryMaterialInfo(parmas).then((res) => {
        if (res.code === "0000") {
          this.tableData = res.materialInfoVos;
          this.pageData.total = res.count;
        }
      });
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData(false);
    },
    handleSizeChange(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(false);
    },
    editLine(row) {
      this.$set(this.editDataSet, row.id, JSON.parse(JSON.stringify(row)));
    },
    saveData(row) {
      let curRow = this.tableData.find((item) => item.id === row.id);
      let reqData = Object.assign(JSON.parse(JSON.stringify(curRow)), this.editDataSet[row.id]);
      //计算素材综合效果
      // let materialEffect = this.computedMaterilEffect(reqData);
      // reqData.materialEffect = materialEffect;

      modifyMaterialStatus([reqData]).then((res) => {
        if (res.code === "0000") {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          Object.assign(curRow, this.editDataSet[row.id]);
          this.$delete(this.editDataSet, row.id);
        }
      });
    },
    cancel(row) {
      this.$delete(this.editDataSet, row.id);
    },
    showLog(data) {
      this.$refs.logModalRef.showModal(data);
    },
    computedMaterilEffect(data) {
      let numArr = [0, 0, 0, 0]; // 0123分别记录 未上传，已上传，有效，带量
      ["FB", "GG", "TT", "unity", "mintegral", "toutiao", "wechat", "tencent", "kuaishou"].forEach(
        (field) => {
          numArr[data[field]]++;
        }
      );
      if (numArr[2] === 1 && numArr[3] === 0) {
        return 2;
      } else if (numArr[2] > 1 || numArr[3] > 0) {
        return 3;
      } else {
        return 0;
      }
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    batchApply() {
      let copyData = JSON.parse(JSON.stringify(this.multipleSelection));
      const { channelId, effectId } = this.filterBatch;
      if (!channelId || !effectId) {
        return;
      }
      let flag = true;
      let message = "";
      const effectName = (this.effectList.find((child) => child.value === effectId) || {}).label;
      const channelName = (this.channelList.find((child) => child.value === channelId) || {}).label;
      copyData.map((item) => {
        // 批量修改素材综合效果
        if (channelId === "materialEffect" && !this.isCanSetEffect(item)) {
          message = `批量选择的素材中存在非素材综合效果的渠道全部为“已上传”或“未上传”状态，素材综合效果不允许修改成${effectName}状态`;
          flag = false;
        } else if (item[channelId] > 1 && effectId === 1) {
          message = `批量选择的素材的${channelName}渠道不是“已上传”或“未上传”的状态，不允许修改成${effectName}状态`;
          flag = false;
        } else if (item[channelId] === 0 && effectId > 1 && channelId !== "materialEffect") {
          message = `批量选择的素材的${channelName}渠道存在未上传的状态，不允许修改成${effectName}状态`;
          flag = false;
        } else {
          item[channelId] = effectId;
          return item;
        }
      });
      if (flag) {
        modifyMaterialStatus(copyData).then((res) => {
          if (res.code === "0000") {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.searchData(true);
          }
        });
      } else {
        this.$message({
          message,
          type: "error",
        });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: auto;
  .header-filter {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px 0px 24px;
    .filter-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 15px;
      }
    }
    .select-wrap {
      display: flex;
      margin-top: 16px;
      .select-item {
        width: 200px;
        margin: 0px 24px 16px 0px;
      }
      .data-range {
        position: relative;
        margin-bottom: 16px;
        /deep/.el-range__icon {
          position: absolute;
          right: 6px;
          top: 0px;
        }
        /deep/.el-range-separator {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.25);
        }
      }
    }
  }
  .table-wrap {
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 24px;
    height: calc(100vh - 290px);
    display: flex;
    flex-direction: column;
    .batch {
      display: flex;
      height: 45px;
      .batch-title {
        color: rgba(0, 0, 0, 0.85);
        font-weight: 600;
        font-size: 14px;
        line-height: 30px;
      }
      .batch-select-item {
        margin-bottom: 12px;
        margin-right: 24px;
      }
      .batch-btn {
        width: 74px;
        height: 30px;
        border-radius: 2px;
        border: 1px solid rgba(24, 144, 255, 0.45);
        background: rgba(255, 255, 255, 1);
        text-align: center;
        color: rgba(24, 144, 255, 0.45);
        font-size: 14px;
        line-height: 30px;
        cursor: not-allowed;
      }
      .can-click {
        border: 1px solid rgba(24, 144, 255, 1);
        color: rgba(24, 144, 255, 1);
        cursor: pointer;
      }
    }
    .edit-btns {
      display: inline-block;
      margin-right: 16px;
    }
    .input-area {
      /deep/ .el-textarea__inner {
        height: 80px;
        &::-webkit-scrollbar {
          width: 4px;
        }
        &::-webkit-scrollbar-thumb {
          border-radius: 10px;
          -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
          background: rgba(0, 0, 0, 0.2);
        }
      }
    }
    .show-text-area {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .show-text {
      width: 48px;
      height: 24px;
      font-size: 14px;
      text-align: center;
      padding: 4px 8px;
      border-radius: 4px;
      &.wsc {
        font-size: 18px;
      }
      &.ysc {
        color: rgba(24, 144, 255, 1);
        font-size: 20px;
      }
      &.yx {
        background-color: rgba(255, 237, 141, 1);
        color: rgba(170, 105, 8, 1);
      }
      &.yxpro {
        background-color: rgba(143, 235, 207, 1);
        color: rgba(12, 131, 95, 1);
      }
      &.dl {
        background-color: rgba(172, 131, 246, 1);
        color: white;
      }
    }
  }
  .footer-page {
    // padding: 0px 0px 10px 0px;
  }
}
</style>
